'use strict';

angular.module('dashboard', [
    'ui.router',
]);
